import { useEffect, useState } from 'react';
import { getTargetElement } from '../utils/dom';

function useScroll(target) {
  var _useState = useState({
    left: NaN,
    top: NaN
  }),
      position = _useState[0],
      setPosition = _useState[1];

  useEffect(function () {
    var el = getTargetElement(target, document);
    if (!el) return;

    function updatePosition(currentTarget) {
      var newPosition;

      if (currentTarget === document) {
        if (!document.scrollingElement) return;
        newPosition = {
          left: document.scrollingElement.scrollLeft,
          top: document.scrollingElement.scrollTop
        };
      } else {
        newPosition = {
          left: currentTarget.scrollLeft,
          top: currentTarget.scrollTop
        };
      }

      setPosition(newPosition);
    }

    updatePosition(el);

    function listener(event) {
      if (!event.target) return;
      updatePosition(event.target);
    }

    el.addEventListener('scroll', listener);
    return function () {
      el.removeEventListener('scroll', listener);
    };
  }, [target]);
  return position;
}

export default useScroll;